<script lang="ts">
  import type { InboxWorkflowCellProps } from "@kontextwerk/control-web-frame/inbox-workflow/contract"
  import ExistingAppointmentCell from "./_modules/existing-appointment-cell"
  import type { AssignWorkOrderDraft, WorkOrderAssignmentRow } from "../../contract"

  let props: InboxWorkflowCellProps = $props()

  const row = $derived(props.row as unknown as WorkOrderAssignmentRow)
  const draft = $derived(props.draft as AssignWorkOrderDraft)
</script>

<ExistingAppointmentCell {row} {draft} />
